import type { Quantity } from '@common/validation/quantity';
import type { QuantityProps } from '../pages/episodeCategory/customControls/Quantity';
import type { OmittedFormGroupFieldProps } from './FormGroup';

type QuantityFieldProps = Omit<QuantityProps, 'quantity'> & { value: Quantity };

export function computeQuantityProps({
    isClearable,
    maxValue,
    minValue,
    onChange,
    unitError,
    units,
    value,
    valueError,
}: QuantityFieldProps): QuantityProps {
    return {
        isClearable,
        maxValue,
        minValue,
        onChange,
        quantity: value,
        unitError,
        units,
        valueError,
    };
}

export type QuantityFormGroupFieldProps = OmittedFormGroupFieldProps & QuantityFieldProps;
